module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiExtIt.1b00776.ttf";